import React from 'react'
import { Delivery, money } from './billingModel'

export const SourceBadge = ({ source }: { source?: string }) => source === 'manual'
  ? <span className='billing-badge billing-badge-manual'>Na żądanie</span>
  : <span className='billing-badge billing-badge-auto'>Automatyczne</span>

export const DeliveryBadge = ({ delivery }: { delivery: Delivery }) => delivery.status === 'sent'
  ? <span className='billing-badge billing-badge-sent'>Wysłano</span>
  : delivery.status === 'cancelled'
    ? <span className='billing-badge billing-badge-cancelled'>Anulowano</span>
    : <span className='billing-badge billing-badge-pending'>W kolejce</span>

export const Totals = ({ net, vat, gross }: { net: number; vat: number; gross: number }) => <div className='billing-totals'>
  <div className='billing-total'><span>Netto</span><strong data-testid='billing-net'>{money(net)} PLN</strong></div>
  <div className='billing-total'><span>VAT</span><strong data-testid='billing-vat'>{money(vat)} PLN</strong></div>
  <div className='billing-total billing-total-gross'><span>Brutto</span><strong data-testid='billing-gross'>{money(gross)} PLN</strong></div>
</div>

export const Notices = ({ error, message, busy }: { error?: string; message?: string; busy?: boolean }) => <>
  {error && <div className='billing-alert billing-error' role='alert'><p>{error}</p></div>}
  {message && <div className='billing-alert billing-success'><p role='status'>{message}</p></div>}
  {busy && <div className='billing-alert billing-info'><p role='status'>Trwa operacja…</p></div>}
</>
